import { render } from "./glob-col.vue?vue&type=template&id=f0054f3a"
import script from "./glob-col.vue?vue&type=script&lang=js"
export * from "./glob-col.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__